module.exports = __webpack_public_path__ + "a1a749e89f578a49306ec2b055c073da.svg";